






















import Component from 'vue-class-component';
import {CommonReasonDialogRequest} from '@/model/CommonModel';
import {Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonValidators from '@/validator/CommonValidators';
import DefaultFormMixin from '@/views/DefaultFormMixin';
import CommonButton from '@/components/button/CommonButton.vue';
import TextInput from '@/components/input/TextInput.vue';

@Component({
  components: {CommonButton, TextInput, CommonPromptDialog},
  mixins: [DialogEventsMixin, DefaultFormMixin]
})
export default class ResetSyncConfirmDialog extends Mixins(DialogEventsMixin, DefaultFormMixin) {
  private dialogVisible = false;
  private width: string = '400px';
  private onConfirm: any;
  private form: any = {
    data: {
      reason: ''
    },
    rules: {
      reason: [
        {validator: CommonValidators.required(this, 'message.caseinfo.resetSyncDialog.required'), trigger: 'change'}
      ]
    }
  };

  get isVisible() {
    return this.dialogVisible;
  }

  get getWidth() {
    return this.width;
  }

  get isLoading() {
    return this.loading;
  }

  public mounted() {
    this.loading = false;
    this.$modal
        .getEventBus()
        .$on('showResetSyncConfirmDialog', (params: CommonReasonDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideResetSyncConfirmDialog', () => this.cancel());
  }

  public show(params: CommonReasonDialogRequest) {
    const {onConfirm} = params;
    this.onConfirm = onConfirm;
    this.dialogVisible = true;
    this.loading = false;
  }

  public confirm() {
    if (this.isLoading) {
      return;
    }
    this.validation(() => this.submit());
  }

  private submit() {
    this.loading = true;
    if (typeof this.onConfirm === 'function') {
      this.onConfirm({reason: this.form.data.reason});
      this.hide();
    } else {
      this.hide();
    }
  }

  public cancel() {
    this.hide();
  }

  public hide() {
    this.dialogVisible = false;
  }

  public opened($event: any) {
    this.$emit('opened', $event);
    (this.$refs.reason as any)?.focus();
  }

  public afterClosed() {
    this.form.data.reason = '';
    (this.$refs.form as any)?.resetFields();
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showResetSyncConfirmDialog');
    this.$modal.getEventBus().$off('hideResetSyncConfirmDialog');
  }
}
